import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { antiForgeryFormOptions } from '../common/antiForgery';
import { getReturnUrl } from '../common/returnUrl';
import { LogInView } from './logInView';
import { LogInFormValues } from '../common/interfaces';
import { logIn } from '../data/endpointServices';

export const LogIn = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState<boolean>(false);
    const [showSso, setShowSso] = useState<boolean>(true);
    const [serverError, setServerError] = useState<string>('');
    const antiforgeryOptions = antiForgeryFormOptions();
    const returnUrl = getReturnUrl();
    const { errors: fieldsErrors, handleSubmit, register } = useForm();
    const { search } = useLocation();

    useEffect(() => {
        const decodedUri = decodeURIComponent(search);
        const disablessologinview = new URLSearchParams(decodedUri).get('disablessologinview');

        if (disablessologinview === 'true') {
            setShowSso(false);
        }
    }, []);
    
    const submitLogIn = async(data: LogInFormValues) => {
        setLoading(true);

        try {
            const response = await logIn(data.email, data.password, returnUrl, antiforgeryOptions);
            if (response?.data?.r) {
                const newLocation = decodeURIComponent(response.data?.r?.returnUrl);
                window.location.href = newLocation ?? '';
            } else {
                setServerError(t('logInSystemError'));
            }
        } catch (error) {
            if (error?.response?.data?.c === 400) {
                setServerError(error?.response?.data?.e);
            } else if (error?.response?.data?.c === 401) {
                setServerError(t('logInIncorrectInfoError'));
            } else {
                setServerError(t('logInSystemError'));
            }
        } finally {
            setLoading(false);
        }
    };

    return(
        <LogInView 
            submitLogIn={submitLogIn}
            fieldsErrors={fieldsErrors}
            handleSubmit={handleSubmit}
            register={register}
            returnUrl={returnUrl === null ? '' : returnUrl}
            loading={loading}
            serverError={serverError}
            showSso={showSso}
        />
    );
};

